import React, {Component} from 'react';
import {Col, Row, Tabs, Tab, Modal, Button, Tooltip, Checkbox, OverlayTrigger, FormControl} from 'react-bootstrap';
import async  from 'async';
import {v4 as uuidv4}  from 'uuid'
import config from  '../../../config';
import _  from 'lodash';

const tooltip = (
    <Tooltip className="in" id="tooltip-top">
        Add to title
    </Tooltip>
);
const tooltipAddTag = (
    <Tooltip className="in" id="tooltip-top">
        Add tag
    </Tooltip>
);
import Select   from 'react-select'

import {prepareSelectOptionsList} from 'util/Utils';


export default class AdminGBGProductsActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
            _.filter(this.props.allCategories, function (category) {
                return category.AncestorCategories.length > 0
            }),
            {
                label: 'CategoryName',
                value: '_id'
            }), 'label')
        this.categoriesList = _.sortBy(prepareSelectOptionsList(
            _.filter(this.props.allCategories, function (category) {
                return category.AncestorCategories.length == 0
            }),
            {
                label: 'CategoryName',
                value: '_id'
            }), 'label')
        var selectedCategory = ''
        if (!_.isUndefined(this.props.location.query.Category)) {
            var foundCategory = _.find(this.props.allCategories, function (category) {
                return category.AncestorCategories.length == 0 && this.props.location.query.Category == category.TagName
            }.bind(this))
            if (foundCategory) {
                selectedCategory = foundCategory._id
                this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
                    _.filter(this.props.allCategories, function (category) {
                        return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories, 'CategoryID'), selectedCategory)
                    }),
                    {
                        label: 'CategoryName',
                        value: '_id'
                    }), 'label')
            }
        }
        var selectedSubcategory = ''
        if (!_.isUndefined(this.props.location.query.Subcategory)) {
            var foundCategory = _.find(this.props.allCategories, function (category) {
                return category.AncestorCategories.length > 0 && this.props.location.query.Subcategory == category.TagName
            }.bind(this))
            selectedSubcategory = foundCategory ? foundCategory._id : ''
        }

        this.state = {
            assignVariationData: {
                AddTag: false,
                selectedCategory: selectedCategory,
                selectedSubcategory: selectedSubcategory,
                UseInTitle: false
            },
            bulkUpdateModalVisible: false,
            showBulkUpdateErrorsModal: false,
            recordsNotUpdated: [],
            pending: false,
            currentBulkUpdateAction: '',
            customVariationTypeValue: '',
            customVariationTypeLabel: '',
            displayChangeTab: false,
            doNotClearSelectedRecords:false,
        };

    };


    addVariationOption() {
        this.setState({
            customVariationTypeLabel: '',
            customVariationTypeValue: ''
        });

        this.onVariationOptionsChange(_.concat(_.get(this.state.assignVariationData, ['Options'], []), [{
            value: this.state.customVariationTypeValue,
            label: this.state.customVariationTypeLabel
        }]))
    }

    onCategoryChange(option) {
        var selectedSubcategory = this.state.assignVariationData.selectedSubcategory
        if (option) {
            this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
                _.filter(this.props.allCategories, function (category) {
                    return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories, 'CategoryID'), option.value)
                }),
                {
                    label: 'CategoryName',
                    value: '_id'
                }), 'label')
            var foundSelectedSubcategory = _.find(this.subcategoriesList, function (subcategoryOption) {
                return subcategoryOption.value == selectedSubcategory
            })

            if (!foundSelectedSubcategory) {
                selectedSubcategory = '';
            }
        } else {
            this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
                _.filter(this.props.allCategories, function (category) {
                    return category.AncestorCategories.length > 0
                }),
                {
                    label: 'CategoryName',
                    value: '_id'
                }), 'label');
        }
        this.setState({
            'assignVariationData': {
                ...this.state.assignVariationData,
                selectedCategory: option ? option.value : '',
                selectedSubcategory: selectedSubcategory,
            },
        });
    }

    onSubcategoryChange(option) {

        this.setState({
            'assignVariationData': {
                ...this.state.assignVariationData,
                selectedSubcategory: option ? option.value : '',
            },
        });
    }

    onVariationOptionsChange(options) {
        console.log('onVariationOptionsChange', options);
        this.setState({'assignVariationData': {...this.state.assignVariationData, 'Options': options}})
    }

    processAction() {
        var self = this;
        self.setState({pending: false, bulkUpdateModalVisible: false})
        var functionsToCall = []
        console.log('process action', self.state.currentBulkUpdateAction);
        if (self.state.currentBulkUpdateAction == 'assignVariation') {
            if (self.props.adminGBGProducts.selectedProducts.length) {
                var methodData = {
                    "endpoint": "/gbg_products_update",
                    'type': 'post',
                    messageData: {'#1#': 'GBG Products'},
                    messageCode: 'recordsUpdated'
                };
                functionsToCall.push(function (done) {
                    self.props.makeRequest({
                        'recordIDs': _.map(self.props.adminGBGProducts.selectedProducts, '_id'),
                        type: self.state.currentBulkUpdateAction,
                        data: {[self.state.currentBulkUpdateAction + 'Data']: self.state[self.state.currentBulkUpdateAction + 'Data']}
                    }, methodData).then(response => {
                        self.props.search({doNotClearSelectedRecords: true});
                        if (_.find(response.data, function (productUpdateResult) {
                                return productUpdateResult.error
                            })) {
                            self.showBulkUpdateErrorsModal(response.data);
                        }
                        done(null)
                    }).catch(error => {
                        done(error)
                    });
                })

            }
            var selectedCategoryID = false;
            if (_.get(self.state, ['assignVariationData', 'selectedCategory'], false)) {
                selectedCategoryID = _.get(self.state, ['assignVariationData', 'selectedCategory'], false)
            }
            if (selectedCategoryID && _.get(self.state, ['assignVariationData', 'selectedSubcategory'], false)) {
                selectedCategoryID = _.get(self.state, ['assignVariationData', 'selectedSubcategory'], false)
            }
            if (selectedCategoryID) {
                var methodDataUpdateCategory = {
                    "endpoint": "/categories/" + encodeURIComponent(selectedCategoryID),
                    'type': 'patch',
                    messageData: {'#1#': 'Category'},
                    messageCode: 'recordUpdated'
                };

                functionsToCall.push(function (done) {
                    self.props.makeRequest({
                        type: self.state.currentBulkUpdateAction,
                        data: {[self.state.currentBulkUpdateAction + 'Data']: self.state[self.state.currentBulkUpdateAction + 'Data']}
                    }, methodDataUpdateCategory).then(response => {
                        done(null)
                    }).catch(error => {
                        done(error)
                    });
                })
            }
        } else if (self.state.currentBulkUpdateAction == 'assignProductsToNewGBGProduct') {
            functionsToCall.push(function (done) {
                self.props.makeRequest({
                    'products': _.get(self.state[self.state.currentBulkUpdateAction + 'Data'], 'ProductIDs', []),
                    type: 'assignGBGProduct',
                    ActionID:uuidv4(),
                    data: {'assignGBGProductValue': self.state[self.state.currentBulkUpdateAction + 'Data']['GBGProductToAssign']}
                }, {
                    "endpoint": "/products_update",
                    'type':'post',
                    messageData: {'#1#': 'Products'},
                    messageCode : 'Products have been assigned'
                }).then(response => {
                    done(null)
                }).catch(error => {
                    done(error)
                });
            })
        }
        console.log('functionsToCall', functionsToCall);
        async.parallel(functionsToCall,
            function (err, responses) {
                if (err) {

                }
                self.setState({pending: false})
            })
    }

    showBulkUpdateErrorsModal(productsNotUpdated) {
        var recordsNotUpdated = productsNotUpdated.filter(item => {
            return item.error
        });

        this.setState({
            showBulkUpdateErrorsModal: true,
            recordsNotUpdated: recordsNotUpdated,
            bulkUpdateModalVisible: false,
        })
    }

    onSelectTab(event) {
        this.setState({displayChangeTab: !this.state.displayChangeTab})
    }

    renderVariationToAssign() {
        return <Row className=" ">

            <Col md={2} sm={2} xs={6} className="top10 clearfix">
                <Select
                    clearable={false}
                    placeholder="Type"
                    options={config.GBGProductsVariationTypes}
                    onChange={(option) =>
                        this.setState({
                            'assignVariationData': {
                                ...this.state.assignVariationData,
                                Options: [],
                                'InputType': option.value
                            }
                        })
                    }
                    value={ this.state.assignVariationData.InputType}
                />
            </Col>
            <Col md={3} sm={3} xs={6} className="top10">
                <FormControl type="text"
                             onChange={(e) => {

                                 this.setState({
                                     'assignVariationData': {
                                         ...this.state.assignVariationData,
                                         'Label': e.target.value
                                     }
                                 })
                             } }
                             value={ this.state.assignVariationData.Label }
                             placeholder="Label"/>
            </Col>
            { this.state.assignVariationData.InputType == 'select' &&
            <Col md={4} sm={4} xs={6} className="top10">
                <Select
                    clearable={false}
                    multi
                    placeholder=""
                    options={this.props.getVariationOptions(this.state.assignVariationData)}
                    onChange={(options) => this.onVariationOptionsChange(options)}

                    value={ this.state.assignVariationData.Options}
                />
            </Col>
            }
            <Col className="pull-left top5 left18">
                <OverlayTrigger placement="top" overlay={tooltip}>
                    <Checkbox
                        onClick={() => {
                            this.setState({
                                'assignVariationData': {
                                    ...this.state.assignVariationData,
                                    'UseInTitle': !this.state.assignVariationData.UseInTitle
                                }
                            })
                        }}
                        checked={this.state.assignVariationData.UseInTitle}></Checkbox>
                </OverlayTrigger>
            </Col>
            <Col className="pull-left top5">
                <OverlayTrigger placement="top" overlay={tooltipAddTag}>
                    <Checkbox
                        onClick={() => {
                            this.setState({
                                'assignVariationData': {
                                    ...this.state.assignVariationData,
                                    'AddTag': !this.state.assignVariationData.AddTag
                                }
                            })
                        }}
                        checked={this.state.assignVariationData.AddTag}></Checkbox>
                </OverlayTrigger>
            </Col>

        </Row>
    }

    render() {
        //console.log('in render2', this.state  );
         var selectedCategoryID = false;
        if (_.get(this.state, ['assignVariationData', 'selectedCategory'], false)) {
            selectedCategoryID = this.state.assignVariationData.selectedCategory
        }
        if (selectedCategoryID && _.get(this.state, ['assignVariationData', 'selectedSubcategory'], false)) {
            selectedCategoryID = this.state.assignVariationData.selectedSubcategory
        }
        return (
            <div className="action-block">

                <Tabs id="gbgproducts-tabs" defaultActiveKey={'update_records'} onSelect={(e) => {
                    this.onSelectTab(e)
                }}>
                    {/*unmountOnExit - do not render component until the tab is clicked*/}

                    {/*<Tab eventKey={'reports'}  unmountOnExit={true} title="Reports" >*/}
                        {/*<Row>*/}
                            {/*<Col md={3} xs={6} className="top10">*/}
                                {/*<button className="btn btn-primary" disabled={this.state.pending} onClick={ downloadCustomReport.bind(this)}*/}
                                        {/*type="button">*/}
                                    {/*Download report*/}
                                {/*</button>*/}

                            {/*</Col>*/}
                        {/*</Row>*/}
                    {/*</Tab>*/}
                    <Tab eventKey={'update_records'} unmountOnExit={true} title="Change">
                        <Row
                            className={this.state.displayChangeTab  ? 'top10' : ' hidden'}>
                            <Col xs={12} md={6} lg={6}>
                                <Checkbox onChange={(e) => {
                                    this.setState({doNotClearSelectedRecords: !this.state.doNotClearSelectedRecords }, () => {

                                    })
                                }}
                                          checked={this.state.doNotClearSelectedRecords } inline><span className="left5">Keep selected GBG Products</span></Checkbox>
                            </Col>
                        </Row>
                        <Row className={this.state.displayChangeTab ? 'top10' : ' hidden'}>
                            <Col xs={12} md={6} lg={6}>
                                {this.renderVariationToAssign()}
                                { this.state.assignVariationData.InputType == 'select' &&
                                <Row>
                                    <Col md={4} xs={6} className="top10">
                                        <FormControl type="text"
                                                     onChange={(e) => this.setState({
                                                         'customVariationTypeLabel': e.target.value
                                                     })}
                                                     value={this.state.customVariationTypeLabel }
                                                     placeholder="Label"/>
                                    </Col>
                                    <Col md={4} xs={6} className="top10">
                                        <FormControl type="text"
                                                     onChange={(e) => this.setState({
                                                         'customVariationTypeValue': e.target.value
                                                     })}
                                                     value={this.state.customVariationTypeValue }
                                                     placeholder="Value"/>
                                    </Col>
                                    <Col md={4} sm={2} xs={2} className="top10">
                                        <Button className="right10 pull-left btn btn-primary " type="button"
                                                onClick={() => this.addVariationOption() }>
                                            Add
                                        </Button>
                                    </Col>
                                </Row>
                                }
                            </Col>
                            <Col xs={12} sm={4} md={3} className="top10">
                                <Select
                                    tabIndex="0"
                                    placeholder="Category"
                                    clearable={true}
                                    options={this.categoriesList}
                                    onChange={this.onCategoryChange.bind(this)}
                                    value={this.state.assignVariationData.selectedCategory}
                                />

                            </Col>
                            <Col xs={12} sm={4} md={3} className="top10">
                                <Select
                                    tabIndex="0"
                                    placeholder="Subcategory"
                                    clearable={true}
                                    options={this.subcategoriesList}
                                    onChange={this.onSubcategoryChange.bind(this)}
                                    value={this.state.assignVariationData.selectedSubcategory}
                                />

                            </Col>


                            <Col xs={12} className="top15">
                                <button className="text-bold btn btn-primary bg-red border-red" onClick={() => {
                                    this.setState({
                                        bulkUpdateModalVisible: true,
                                        currentBulkUpdateAction: 'assignVariation',
                                        modalTitleMessage: <div>
                                            <span>Variation will be assigned to </span>
                                            { this.props.adminGBGProducts.selectedProducts.length > 0 &&
                                            <span>
                                                  <span
                                                      className="pink">{this.props.adminGBGProducts.selectedProducts.length} </span>
                                                {this.props.adminGBGProducts.selectedProducts.length == 1 ? 'GBG product' : 'GBG products'}
                                              </span>
                                            }
                                            { selectedCategoryID &&
                                            <span>
                                                    <span
                                                    >{(this.props.adminGBGProducts.selectedProducts.length > 0 ? ' and' : '') + ' selected category'}</span></span>
                                            }
                                        </div>
                                    })

                                }}
                                        disabled={(!this.props.adminGBGProducts.selectedProducts.length && !selectedCategoryID) || _.get(this.state.assignVariationData, ['Label'], '') == '' || _.get(this.state.assignVariationData, ['InputType'], '') == ''   }
                                        type="button">
                                    Assign Variation
                                </button>
                            </Col>

                        </Row>

                        <Row
                            className={this.state.displayChangeTab  ? 'top10' : ' hidden'}>


                            <Col xs={12} className="top15">
                                <button className="text-bold bot7 btn btn-primary bg-red border-red" onClick={() => {
                                    this.props.makeRequest({
                                        'recordIDs': _.map(this.props.adminGBGProducts.selectedProducts, '_id'),
                                        lookup: ['Products'],
                                    }, {
                                        "endpoint": "/gbg_products",
                                    }).then(response => {
                                        if (_.size(_.get(response.data, 'data')) == 2) {
                                            var firstGBGProduct = _.find(response.data.data, {'_id': this.props.adminGBGProducts.selectedProducts[0]._id})
                                            var secondGBGProduct = _.find(response.data.data, {'_id': this.props.adminGBGProducts.selectedProducts[1]._id})
                                            console.log('secondGBGProduct', secondGBGProduct);
                                            if (!_.size(_.get(firstGBGProduct, 'AssociatedProducts', []))) {
                                                return this.props.displayMessage({
                                                    'messageType': 'warning',
                                                    'messageCode': 'No products are linked to ' + _.get(firstGBGProduct, 'Brand', '') + ' ' + _.get(firstGBGProduct, 'Model', ''),
                                                });
                                            }
                                            if (!_.get(secondGBGProduct, '_id')){
                                                return this.props.displayMessage({
                                                    'messageType': 'warning',
                                                    'messageCode': 'GBG Product not found',
                                                });
                                            }
                                            this.setState({
                                                bulkUpdateModalVisible: true,
                                                assignProductsToNewGBGProductData: {
                                                    ProductIDs: _.map(firstGBGProduct.AssociatedProducts, '_id'),
                                                    GBGProductToAssign: secondGBGProduct._id,
                                                },
                                                currentBulkUpdateAction: 'assignProductsToNewGBGProduct',
                                                modalTitleMessage: <div>
                                                    <span>{_.size(_.get(firstGBGProduct, 'AssociatedProducts', [])) + ' ' + ( _.size(_.get(firstGBGProduct, 'AssociatedProducts', [])) == 1  ? 'product' : 'products') + ' linked to'} </span>
                                                    <span
                                                      className="pink">{_.get(firstGBGProduct, 'Brand', '') + ' ' + _.get(firstGBGProduct, 'Model', '') } </span>
                                                    <span>will be assigned to </span>
                                                    <span
                                                        className="pink">{_.get(secondGBGProduct, 'Brand', '') + ' ' + _.get(secondGBGProduct, 'Model', '') } </span>

                                                </div>
                                            })
                                        }
                                    })
                                }}
                                    disabled={this.props.adminGBGProducts.selectedProducts.length  !== 2   }
                                    type="button">
                                    Assign products to selected GBG Product
                                    </button>
                                {  (this.props.adminGBGProducts.selectedProducts.length == 1 || this.props.adminGBGProducts.selectedProducts.length == 2) &&
                                <span className="left10">
                                    <span>Products linked to </span>
                                    <span
                                        className="pink">{_.get(this.props.adminGBGProducts.selectedProducts[0], 'Brand', '') + ' ' + _.get(this.props.adminGBGProducts.selectedProducts[0], 'Model', '') } </span>
                                    <span>will be assigned to </span>
                                </span>
                                }
                                {  this.props.adminGBGProducts.selectedProducts.length== 2 &&
                                    <span
                                        className="pink">{_.get(this.props.adminGBGProducts.selectedProducts[1], 'Brand', '') + ' ' + _.get(this.props.adminGBGProducts.selectedProducts[1], 'Model', '') }
                                    </span>
                                }
                                    </Col>
                                    </Row>
                                    </Tab>
                                    </Tabs>

                                    <Modal show={this.state.bulkUpdateModalVisible}
                                    onHide={(e) => this.setState({currentBulkUpdateAction: '', bulkUpdateModalVisible: false})}>
                                    <Modal.Header>
                                    <Modal.Title>{this.state.modalTitleMessage}</Modal.Title>
                                    </Modal.Header>

                                    <Modal.Footer>
                                    <Button onClick={(e) => this.setState({
                                        currentBulkUpdateAction: '',
                                        bulkUpdateModalVisible: false
                                    })}>Cancel</Button>
                                    <Button
                                    disabled={this.state.pending}
                                    onClick={(e) => this.processAction() }
                                    bsStyle="primary">{ _.startCase(this.state.currentBulkUpdateAction)}</Button>
                                    </Modal.Footer>
                                    </Modal>

                                    <Modal show={this.state.showBulkUpdateErrorsModal}
                                    onHide={() => this.setState({
                                        showBulkUpdateErrorsModal: false
                                    })}>
                                    <Modal.Header closeButton>
                                    <Modal.Title> {this.state.recordsNotUpdated.length} {this.state.recordsNotUpdated.length == 1 ? 'GBG product was ' : 'GBG products were'}
                                    not updated.</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                    <div>
                                    <Row className="bot20">
                                    <Col md={12} sm={12} xs={12}
                                    style={{textAlign: 'justify'}}>
                                    <div className="bot10">
                                    Please, check email for update error details for the
                                    following {this.state.recordsNotUpdated.length == 1 ? 'GBG product' : 'GBG products'}:
                                    </div>
                                    {this.state.recordsNotUpdated.map((updateProductErrorResult, i) => <div style={{
                                        fontWeight: '500', marginTop: 3,
                                    }}
                                                                                                            key={'x' + i}>{'Brand: ' + _.get(updateProductErrorResult, ['data', 'Brand'], '') + ' Model: ' + _.get(updateProductErrorResult, ['data', 'Model'], '')}</div>)}
                                    </Col>
                                    </Row>
                                    </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                    <Row className="left0">
                                    <Col md={12} sm={12} xs={12} className="pleft0">
                                    <Button className="pull-right btn right20 btn-default"
                                    type="button"
                                    onClick={() => this.setState({
                                    showBulkUpdateErrorsModal: false
                                })}>
                                    OK
                                    </Button>
                                    </Col>
                                    </Row>
                                    </Modal.Footer>
                                    </Modal>
                                {this.state.pending &&
                                    <div className="pending-box"></div>
                                }
                                    </div >
                                    );

                                    }
                                }



